import React from "react";
import { Card, CardContent } from "../ui/card";
import { Badge } from "../ui/badge";

const DASHBOARD_TYPOGRAPHY = {
  body: "text-sm font-medium text-white",
  meta: "text-sm text-white/72",
};

const SignalsTab = ({ displayedSignals }) => (
  <div className="h-full overflow-auto">
    <div className="space-y-3">
      {displayedSignals.length === 0 ? (
        <div className="text-center py-8 text-white/70">
          No signals detected
        </div>
      ) : (
        displayedSignals.map((signal, index) => (
          <Card key={index} className="bg-white/5 border-white/10">
            <CardContent className="p-4">
              <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div>
                  <div className={DASHBOARD_TYPOGRAPHY.body}>{signal.type}</div>
                  <div className={DASHBOARD_TYPOGRAPHY.meta}>{signal.signal}</div>
                </div>
                <Badge className={signal.strength === "STRONG" ? "bg-red-500/20 text-red-500 border-red-500/30" : "bg-yellow-500/20 text-yellow-500 border-yellow-500/30"}>
                  {signal.strength}
                </Badge>
              </div>
            </CardContent>
          </Card>
        ))
      )}
    </div>
  </div>
);

export default React.memo(SignalsTab);
